var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import TagChip from '../../../tagChip/components/TagChip';
import Autocomplete from '@mui/material/Autocomplete';
var TagFilter = function (_a) {
    var tagColumn = _a.tagColumn, onFilterChange = _a.onFilterChange;
    var _b = useState(false), isPopupOpen = _b[0], setIsPopupOpen = _b[1];
    var _c = useState([]), options = _c[0], setOptions = _c[1];
    var _d = useState(tagColumn.filter), value = _d[0], setValue = _d[1];
    // set a filter value with value from column object. This happens when the Tag for filtering is set outside of this component
    useEffect(function () {
        setValue(tagColumn.filter);
    }, [tagColumn.filter]);
    var onInputChangeHandler = function (e, text) {
        if (tagColumn.doSearch && text.length >= 1) {
            tagColumn.doSearch(text)
                .then(setOptions)
                .catch(function (err) { return console.error('Can not fetch options for tag filter', err); });
        }
        // the popup should be opened if:
        // 1. the search text is at least 1 character long
        // 2. there isn't already selected tag
        setIsPopupOpen(text.length >= 1 && !value);
    };
    var onChangeHandler = function (e, tag) {
        setValue(tag);
        onFilterChange(tagColumn, tag);
    };
    return (React.createElement(Autocomplete, { disabled: !tagColumn.filterable, renderInput: function (params) { return React.createElement(TextField, __assign({ className: 'columnFilter' }, params)); }, renderTags: function (tags, getTagProps) {
            return tags.map(function (tag, index) {
                var _a = getTagProps({ index: index }), onDelete = _a.onDelete, className = _a.className;
                return (React.createElement(TagChip, { key: index, label: tag.name, className: className, onDelete: onDelete }));
            });
        }, autoHighlight: true, value: value, filterSelectedOptions: true, options: value ? __spreadArray([value], options, true) : options, getOptionLabel: function (tag) { return tag.name; }, forcePopupIcon: false, open: isPopupOpen, onChange: onChangeHandler, onInputChange: onInputChangeHandler, onClose: function () { return setIsPopupOpen(false); } }));
};
export default TagFilter;
//# sourceMappingURL=TagFilter.js.map